import { httpClient } from '@/lib/http-client';
import { WAREHOUSE_ENDPOINTS } from '@/config/api';
import { BaseApi } from './base-api';
import type {
  Facility,
  UnitType,
  UnitTypesList,
  Unit,
  UnitsList,
  FacilitiesWithUnitTypesList,
  FacilityStatistics,
} from '@/types/warehouse';

export class WarehouseApi extends BaseApi {
  static async getFacilities(): Promise<FacilitiesWithUnitTypesList> {
    return httpClient.get<FacilitiesWithUnitTypesList>(WAREHOUSE_ENDPOINTS.FACILITIES);
  }

  static async getFacilityByCode(facilityCode: string): Promise<Facility> {
    return httpClient.get<Facility>(WAREHOUSE_ENDPOINTS.FACILITY_BY_CODE(facilityCode));
  }

  static async getUnitTypes(facilityCode: string): Promise<UnitTypesList> {
    return httpClient.get<UnitTypesList>(WAREHOUSE_ENDPOINTS.FACILITY_UNIT_TYPES(facilityCode));
  }

  static async getUnitTypeByCode(facilityCode: string, unitType: string): Promise<UnitType> {
    return httpClient.get<UnitType>(WAREHOUSE_ENDPOINTS.FACILITY_UNIT_TYPE(facilityCode, unitType));
  }

  static async getUnits(facilityCode: string): Promise<UnitsList> {
    return httpClient.get<UnitsList>(WAREHOUSE_ENDPOINTS.FACILITY_UNITS(facilityCode));
  }

  static async getUnitsByType(facilityCode: string, unitType: string): Promise<UnitsList> {
    return httpClient.get<UnitsList>(WAREHOUSE_ENDPOINTS.FACILITY_UNIT_TYPE_UNITS(facilityCode, unitType));
  }

  static async getUnit(facilityCode: string, unitType: string, unitCode: string): Promise<Unit> {
    return httpClient.get<Unit>(WAREHOUSE_ENDPOINTS.FACILITY_UNIT(facilityCode, unitType, unitCode));
  }

  static async getPublicStatistics(facilityCode: string): Promise<FacilityStatistics> {
    return httpClient.get<FacilityStatistics>(WAREHOUSE_ENDPOINTS.FACILITY_PUBLIC_STATISTICS(facilityCode));
  }
}
